import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import CarouselForm from './CarouselForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';
import style from './styles/style.module.css';


class EditCarouselModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            deleteConfirm: false,
            fetching: false,
        };
    }
    submitHandler = ( { carousel } ) => {
        this.setState( { fetching: true } );

        this.props.updateCarousel( carousel.id, carousel )
        .then( ( newCarousel ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newCarousel );
        } );
    }
    toggleDeleteConfirmation = ( state ) => {
        return () => {
            this.setState( { deleteConfirm: state } );
        };
    }
    deleteCarousel = () => {
        this.setState( { fetching: true } );
        this.props.deleteCarousel( this.props.carousel.id )
        .then( () => {
            this.setState( { fetching: false, deleteConfirm: false } );
            this.props.onSubmit && this.props.onSubmit( null );
        } );
    }
    render() {
        const { carousel } = this.props;

        var initialValues = {
            ...carousel,
            published: ( carousel.status === 'published' ),
        };

        return (
            <DLModal title='Edit Carousel'
            closeHandler={ this.props.closeModal }>
                <div>
                    <CarouselForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                    { this.renderDeleteSection() }
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }

    renderDeleteSection = () => {
        if( this.state.deleteConfirm ) {
            return (
                <div className={style.deleteLink}>
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS CAROUSEL?</p>
                    <p>
                        <span className={ style.confirmDelete }
                        onClick={ this.deleteCarousel }>
                            DELETE CAROUSEL
                        </span>
                        <span className={ style.cancelDelete }
                        onClick={ this.toggleDeleteConfirmation( false ) }>
                            CANCEL
                        </span>
                    </p>
                </div>
            );
        }
        return (
            <div className={style.deleteLink}>
                <span
                onClick={ this.toggleDeleteConfirmation( true ) }>
                    DELETE THIS CAROUSEL
                </span>
            </div>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        updateCarousel: ( id, data ) => {
            return dAPI.patch( `/admin/curated-carousels/${ id }`, data );

        },
        deleteCarousel: ( id ) => {
            return dAPI.delete( `/admin/curated-carousels/${ id }` );

        },
    };
};

export default connect( null, mapDispatchToProps )( EditCarouselModal );
